import { http } from './http';

export interface RegisterPayload {
  phone: string;
  name: string;
  aadhaarNumber: string;
  drivingLicense: string;
  vehicleType: string;
  vehicleNumber: string;
}

export interface LoginPayload {
  phone: string;
}

export interface VerifyOtpPayload {
  phone: string;
  otp: string;
}

export const authApi = {
  register(data: RegisterPayload) {
    return http.post('/rider/auth/register', data);
  },
  login(data: LoginPayload) {
    return http.post('/rider/auth/login', data);
  },
  verifyOtp({ phone, otp }: VerifyOtpPayload) {
    return http.post<{ token: string }>(`/rider/auth/verify-otp/${phone}`, {
      otp,
    });
  },
};
